import { useEffect } from "react";

const DEFAULT_SITE_NAME = "Kyros Games";
const DEFAULT_IMAGE = "https://kyrosgames.com/logo512.png";
const DEFAULT_IMAGE_ALT = "Kyros Games, videogame autoprodotti per Windows";

function upsertMeta(selector, attribute, value, content) {
  let meta = document.querySelector(selector);
  if (!meta) {
    meta = document.createElement("meta");
    meta.setAttribute(attribute, value);
    document.head.appendChild(meta);
  }
  meta.setAttribute("content", content);
}

export default function SEO({
  title,
  description,
  canonical,
  structuredData,
  image = DEFAULT_IMAGE,
  imageAlt = DEFAULT_IMAGE_ALT,
  type = "website",
  robots
}) {
  useEffect(() => {
    const resolvedTitle = title || DEFAULT_SITE_NAME;
    const resolvedDescription = description || "Kyros Games: videogame autoprodotti per Windows, Store diretto e launcher ufficiale.";
    const resolvedCanonical =
      canonical ||
      (typeof window !== "undefined" ? window.location.href : "https://kyrosgames.com/");

    document.title = resolvedTitle;

    upsertMeta('meta[name="description"]', "name", "description", resolvedDescription);
    upsertMeta('meta[property="og:site_name"]', "property", "og:site_name", DEFAULT_SITE_NAME);
    upsertMeta('meta[property="og:title"]', "property", "og:title", resolvedTitle);
    upsertMeta('meta[property="og:description"]', "property", "og:description", resolvedDescription);
    upsertMeta('meta[property="og:url"]', "property", "og:url", resolvedCanonical);
    upsertMeta('meta[property="og:type"]', "property", "og:type", type);
    upsertMeta('meta[property="og:image"]', "property", "og:image", image);
    upsertMeta('meta[property="og:image:alt"]', "property", "og:image:alt", imageAlt);
    upsertMeta('meta[name="twitter:card"]', "name", "twitter:card", "summary_large_image");
    upsertMeta('meta[name="twitter:title"]', "name", "twitter:title", resolvedTitle);
    upsertMeta('meta[name="twitter:description"]', "name", "twitter:description", resolvedDescription);
    upsertMeta('meta[name="twitter:image"]', "name", "twitter:image", image);

    if (robots) {
      upsertMeta('meta[name="robots"]', "name", "robots", robots);
    } else {
      document.querySelector('meta[name="robots"]')?.remove();
    }

    let link = document.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      document.head.appendChild(link);
    }
    link.setAttribute("href", resolvedCanonical);

    const scriptId = "seo-structured-data";
    const existing = document.getElementById(scriptId);
    if (existing) existing.remove();

    if (structuredData) {
      const script = document.createElement("script");
      script.type = "application/ld+json";
      script.id = scriptId;
      try {
        script.text = JSON.stringify(structuredData);
        document.head.appendChild(script);
      } catch (_error) {
        // Fail silently; malformed data should not break the page.
      }
    }
  }, [canonical, description, image, imageAlt, robots, structuredData, title, type]);

  return null;
}
